import { render, staticRenderFns } from "./AppSubHeader.vue?vue&type=template&id=23c0416c&scoped=true&"
import script from "./AppSubHeader.vue?vue&type=script&lang=js&"
export * from "./AppSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppSubHeader.vue?vue&type=style&index=0&id=23c0416c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c0416c",
  null
  
)

export default component.exports